import * as React from 'react';
import * as Redux from 'redux';
import * as ReactRedux from 'react-redux';
import * as Tgcc from '../tgccGlobal';
import * as TgccRequest from '../tgccRequest';
import Radium, { StyleRoot } from 'radium';
import {connect} from 'react-redux';
import {CSSProperties} from 'react';
import {BulletLine} from '../Components/BulletLine';
import {ProductCategory} from './ProductCategory';
import {ProductCard} from './ProductCard';
import {BrandCard} from './BrandCard';
import {ProductSwatch} from './ProductSwatch';
import {CloseX} from '../Components/CloseX';
import {ScreenDoor} from '../Components/ScreenDoor';

const categoryContainerStyle : CSSProperties = {
    position: 'relative',
    width: '99%',
    maxHeight: '400px',
    minHeight: '140px',
    display: 'flex',
    flexDirection: 'column',
    padding: '10px 30px',
    textTransform: 'uppercase',
    boxShadow: Tgcc.Styles.boxShadow,
    backgroundColor: 'white',
    marginBottom: '15px',
    flexShrink: 0,
    '@media (max-width:800px) and (max-height:1280px)': {
        width:'95%'
    },
    '@media (max-width:768px) and (max-height:1366px)': {
        width:'94%'
    },
    '@media (max-width:768px) and (max-height:1024px)': {
        width:'94%'
    },
    '@media (max-width:414px)': {
        width:'380px',
        height:'202px'
    },
    '@media (max-width:375px)': {
        height:'170px',
        width:'305px'
    },
    '@media (max-width:320px)': {
        width:'260px',
        height:'170px'
    }
};
const searchStyle : CSSProperties = {
    display: 'flex',
    alignSelf: 'center',
    fontFamily: 'CenturyGothic',
    fontSize: '16px',
    letterSpacing: '6px',
    backgroundColor: Tgcc.Styles.inputBackground,
    textAlign: 'center',
    border: 'none',
    padding: '3px 0 3px 7px',
    textTransform: 'uppercase',
    width: '400px',
    '@media (max-width:1024px) and (max-height:1366px)': {
        margin:'auto'
    },
    '@media (max-width:768px) and (max-height:1024px)': {
        margin:'auto'
    },
    '@media (max-width:360px)': {
       lineHeight:'25px',
    },
    '@media (max-width:320px)': {
        width:'265px',
        lineHeight:'20px'
    }
};
const smHeadStyle : CSSProperties = {
    display: 'flex',
    alignSelf: 'center',
    fontFamily: 'CenturyGothic',
    fontSize: '8px',
    letterSpacing: '5px'
};

const categoryListStyle : CSSProperties = {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    maxHeight: '100px',
    paddingBottom: '5px',
    overflowX: 'hidden',
    overflowY: 'auto',
    marginTop: '15px',
    marginLeft: '35px',
    lineHeight: '15px',
    '@media (max-width:414px)': {
        maxHeight:'160px'
    },
    '@media (max-width:375px)': {
        maxHeight:'150px'
    },
    '@media (max-width:320px)': {
        maxHeight:'156px'
    }
};

const selectorStyle : CSSProperties = {
    position: 'relative',
    display: 'flex',
    zIndex: 9,
    margin: '50px auto',
    width: '75%',
    maxHeight: '80%',
    minHeight: '500px',
    boxShadow: Tgcc.Styles.boxShadow,
    backgroundColor: 'rgba(255,255,255,0.96)',
    flexDirection: 'column',
    justifyContent: 'space-around',
    alignItems: 'center',
    padding: '15px',
};
/*remove flewWrap for straight line list...looks cool*/
const catalogStyle : CSSProperties = {
    display: 'flex',
    flexWrap: 'wrap',
    width: '100%',
    flexGrow: 2,
    overflowX: 'hidden',
    overflowY: 'auto',
};

const searchIcon: CSSProperties = {
    width:'20px',
    height:'20px'
}
const searchFormStyle: CSSProperties = {
    textAlign:'center',
    marginBottom:'0px'
}
const searchBtn: CSSProperties = {
    padding:'0px',
    backgroundImage: 'url('+ Tgcc.ResolveUrl('~/images/search_button.png') +')',
    width: '25px',
    height: '27px',
    backgroundSize: 'cover',
    marginTop:'-29px',
    float:'right',
    marginRight:'40px',
}

class ProductSelectProps extends Tgcc.BaseProps {
    proof : Tgcc.Proof;
    searchFilter: string;
}

type StateType = {
    filter: string,
    category: Tgcc.ProductCategory,
    brand: string,
    product: Tgcc.Product,
    selectedSwatch: Tgcc.Product,
    zoomProduct: Tgcc.Product,
    ProductCategories: Tgcc.ProductCategory[],
    Products: Tgcc.Product[],
    ProductBrands: Tgcc.ProductBrand[],
    BrandsDict: any,
    StyleSet: Tgcc.Product[],
    documentOverflow: string,
}

class _ProductSelector extends React.Component < ProductSelectProps, any > {

    selectedCategory : string = null;
    selectedBrand : Tgcc.ProductBrand = null;
    state: StateType = {
        filter: null,
        category: null,
        brand: null,
        product: null,
        selectedSwatch: null,
        zoomProduct: null,
        ProductCategories: null,
        Products: null,
        ProductBrands: null,
        BrandsDict: null,
        StyleSet: null,
        documentOverflow: null,
    }
    
    componentWillUnmount() {
        document.body.style.overflow = this.state.documentOverflow;
    }

    componentWillMount() {
        this.setState({documentOverflow: document.body.style.overflow});
        document.body.style.overflow = 'hidden';
        this.clearState();
        TgccRequest.getProductCategories(null, (categories : Tgcc.ProductCategory[]) => this.productCategoriesLoaded(categories));
        TgccRequest.getProductBrands(null, (brands : Tgcc.ProductBrand[]) => this.productBrandsLoaded(brands));
    }

    clearState = () => {
        this.setState({
            filter: null,
            category: null,
            brand: null,
            product: null,
            selectedSwatch: null,
            zoomProduct: null,
            ProductCategories: null,
            Products: null,
            ProductBrands: null,
            BrandsDict: null,
            StyleSet: null});
        this.props.dispatch({ type: Tgcc.StateAction.FilterProductsByCategory, payload: null})
    }


    productCategoriesLoaded(categories : Tgcc.ProductCategory[]) {
        this.setState({ProductCategories: categories});
    }

    getProductCategories() {
        var categories = new Array();
        for (var i in this.state.ProductCategories) {
            var cat: Tgcc.ProductCategory = this.state.ProductCategories[i];
            categories.push(
                <ProductCategory key={i} category={cat} onChange={this.handleFilterByCategory}></ProductCategory>
            )
        };
        return categories;
    }

    handleFilterByCategory = (category: Tgcc.ProductCategory) =>{
        // 0 == ALL Categories
        var catId = 0;
        if(category)
            catId = category.id;
        TgccRequest.getProductsByCategoryBrandFiltered(null, catId, null, this.state.filter, (products : Tgcc.Product[]) => this.productsLoaded(products))
        this.setState({category: category});
    };
    productBrandsLoaded(brands : Tgcc.ProductBrand[]) {
        var brandsDict={};
        brands.forEach( (brand:Tgcc.ProductBrand) => brandsDict[brand.brand] = brand);
        this.setState({ProductBrands: brands, BrandsDict: brandsDict});
    }

    brandsVisible: boolean = false;
    getProductBrands() {
        this.brandsVisible = false;
        
        if(this.state.filter)
            return;

        if(this.state.category)
            return;

        if (this.state.brand) 
            return;
        
        var brands = new Array();
        if (!this.state.ProductBrands) {
            brands.push( <Tgcc.LoadingElement key={1}/> );
        } else {
            for (var i in this.state.ProductBrands) {
                brands.push(<BrandCard key={i}
                    brand={this.state.ProductBrands[i]as Tgcc.ProductBrand}
                    onSelect={this.handleBrandSelection}/>)
            };
            this.brandsVisible = true;
        }
        return brands;
    }

    handleBrandSelection = (brand : Tgcc.ProductBrand) => {
        // 0 == ALL Categories
        var catId = 0;
        if(this.state.category)
            catId = this.state.category.id;
        TgccRequest.getProductsByCategoryBrandFiltered(null, catId, brand.brand, this.state.filter, (products : Tgcc.Product[]) => this.productsLoaded(products))
        this.setState({brand: brand});
    };

    productsLoaded(products : Tgcc.Product[]) {
        this.setState({Products: products});
    }

    productsVisible: boolean = false;
    getProductItems() {
        this.productsVisible = false;
        if (this.state.product)
            return;

        if(!this.state.Products){
            return;
        }

        if(this.state.category || this.state.brand || this.state.filter){
            var products = new Array();
            if(this.state.Products.length == 0){
                var noItemsStyle = { fontFamily: 'CenturyGothic', fontSize:'24px', textAlign: 'center', width: '100%', textTransform: 'uppercase', alignSelf: 'center'};
                products.push( <div key="none" style={noItemsStyle}>No matching items</div>);
            } 

            for(var i in this.state.Products){
                var product: Tgcc.Product = this.state.Products[i];
                var brand: Tgcc.ProductBrand = this.state.BrandsDict[product.brand];
                products.push(<ProductCard key={i} product={product} brand={brand} onSelect={this.handleProductSelection} />);
            }
            this.productsVisible = true;
            return products;
        }
    }

    getBackButton(){
        var style : CSSProperties = {
            fontSize: '14px',
            letterSpacing: '3px',
            textAlign: 'center',
            textTransform: 'uppercase',
            marginTop: '10px',
            backgroundColor: Tgcc.Styles.buttonBackground,
            border: '1px solid transparent',
            width: '40%',
            cursor: 'pointer'
        };
        if (this.productsVisible)
            return ( <div className="hoverBorder" style={style} onClick={this.handleBackToBrands}>back</div>)
    
        if (this.brandsVisible)
            return ( <div className="hoverBorder" style={style} onClick={this.handleBackToProof}>back</div>)
    }

    handleBackToProof = () => {
        this.props.dispatch({type: Tgcc.StateAction.SetEditState, payload: Tgcc.EditStates.None})
    }

    handleBackToBrands = () => {
        this.setState({
            filter: null,
            category: null,
            brand: null,
            product: null,
            selectedSwatch: null,
            zoomProduct: null,
            StyleSet: null,
            Products: null,
        });
    }

    handleProductSelection = (product : Tgcc.Product) => {
        product.displayIndex = 0; // initialize the first index
        this.setState({product: product, selectedSwatch: product});
        TgccRequest.getProductStyleSet(product, this.productStyleSetLoaded);
    }

    productStyleSetLoaded = (products : Tgcc.Product[]) => {
        this.setState({StyleSet: products});
    }

    handleProductImageError = (event: React.SyntheticEvent<HTMLImageElement>) => {
        event.currentTarget.src = Tgcc.Styles.missingProductImageSrc;
    }

    handleSwatchImageError = (event: React.SyntheticEvent<HTMLImageElement>) => {
        event.currentTarget.src = Tgcc.Styles.missingProductImageSrc;
        event.currentTarget.style.backgroundColor = '#123456';
    }

    selectedImageStyle: CSSProperties = {
         width: 'auto',
         maxWidth: '250px',
         maxHeight: '90%',
         alignSelf: 'center',
         cursor: 'zoom-in',
         '@media (max-width:320px)': {
             maxWidth:'125px'
         }
    }

    zoomProduct = () => {
        this.setState({zoomProduct: this.state.selectedSwatch});
    }
    hideFullSizeProduct = () => {
        this.setState({zoomProduct: null});
    }

    getselectedSwatch() {
        return (
            <img
            src={this.state.selectedSwatch.thumbnail}
            style={this.selectedImageStyle}
            onClick={this.zoomProduct}
            onError={this.handleProductImageError}
            className="selectedImageStyle" />)
    }

    getProductStyleSwatches() {
        if (!this.state.StyleSet) 
            return;

        var styles = new Array();
        for (var i in this.state.StyleSet) {
            var product: Tgcc.Product = this.state.StyleSet[i];
            product.displayIndex = Number(i);
            styles.push(<ProductSwatch
                key={product.brand+product.style+product.colorName}
                product={product}
                selected={this.state.selectedSwatch}
                callback={this.handleSwatchClick}/>)
        }
        return styles;
    }
  
    getProductDetail = () => {
        if(!this.state.product)
            return;

        if (!this.state.StyleSet) 
            return;
        
        var detailStyle : CSSProperties = {
            width: '800px',
            minHeight: '400px',
            marginBottom: '20px',
            boxShadow: Tgcc.Styles.boxShadow,
            backgroundColor: 'white',
            fontFamily: 'CenturyGothic',
            padding: '5px 30px 15px 30px',
            position: 'relative'
        };

        var brandStyle : CSSProperties = {
            textAlign: 'center',
            fontSize: '40px',
            lineHeight: '40px',
            letterSpacing: '5px',
            textTransform: 'uppercase',
            '@media (max-width:414px)' : {
                fontSize:'20px'
            },
            '@media (max-width:320px)': {
                fontSize:'16px'
            }
        };

        var boxStyle : CSSProperties = {
            border: '1px solid black',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-around',
            alignItems: 'center',
            backgroundColor: 'white'
        };
        var currentStyle : CSSProperties = {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-around',
            maxWidth: '300px',
            maxHeight: '90%',
            margin: '50px 0',
            flexShrink: 1,
            alignSelf: 'center',
            '@media (max-width:414px)': {
                margin:'25px 0'
            }
        };

        var swatchesStyle : CSSProperties = {
            display: 'flex',
            flexDirection: 'row',
            flexFlow: 'wrap',
            justifyContent: 'center',
            cursor: 'pointer',
            alignSelf: 'center',
            flexShrink: 1,
            maxWidth: '330px',
            maxHeight: '300px',
            margin: '20px 0',
            overflowY: 'auto',
            '@media (max-width:1439px) and (min-width:769px)': {
                maxHeight:'300px'
            },
            '@media (max-width:768px) and (min-height:768px)': {
                maxHeight:'300px'
            },
            '@media(max-height:734px)': {
                maxHeight:'200px'
            },
            '@media (max-width:375px)': {
                maxHeight:'230px',
                maxWidth:'130px'
            },
            '@media (max-width:360px)': {
                maxHeight:'200px'
            },
            '@media (max-width:320px)': {
                maxHeight:'195px',
                maxWidth:'108px'
            }

        };

        var footerStyle : CSSProperties = {
            display: 'flex',
            justifyContent: 'space-between'
        };

        var colorStyle : CSSProperties = {
            fontSize: '26px',
            width: '100%',
            letterSpacing: '2px',
            '@media (max-width:320px)': {
                fontSize:'12px'
            }
        };

        var detailHdrStyle: CSSProperties = {
            fontSize: '15px',
            width: '100%',
            textTransform: 'uppercase',
            marginTop: '10px',
            textAlign: 'center',
            '@media (max-width:320px)': {
                fontSize:'12px'
            }
        }
        var detailStyle: CSSProperties = {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-around',
            fontSize: '15px',
            width: '100%',
            textAlign: 'center',
            '@media (max-width:414px)': {
                overflow:'auto'
            },
            '@media (max-width:320px)': {
                fontSize:'12px'
            }
        }
        var style: CSSProperties = {

        }
        var description = this.state.selectedSwatch ? this.state.selectedSwatch.description : null;
        var features = this.state.selectedSwatch ? this.state.selectedSwatch.features : null;
        var specs = this.state.selectedSwatch ? this.state.selectedSwatch.specs : null;
        
        var selectedColor = this.state.selectedSwatch ? this.state.selectedSwatch.colorName : null;
        let btnStyle = Object.assign( {}, Tgcc.Styles.grayButton, {width: '40%', height: '17px', lineHeight: "17px", margin: '5px 0'});
        return (
            <div style={detailStyle}>
                <div style={brandStyle} className="brandStyle" >{this.state.product.brand}</div>
                <div style={boxStyle}>
                    <div className="productImgStyle" style={currentStyle}>
                        {this.getselectedSwatch()}
                    </div>
                    <div className="swatchesStyle" style={swatchesStyle}>
                        <div className="colorStyle" style={colorStyle}>{selectedColor}</div>
                        {this.getProductStyleSwatches()}
                        <div style={style}>
                            <div style={detailHdrStyle}>Product Description</div>
                            <div style={detailStyle}>{description}</div>
                            <div style={detailStyle}>{features}</div>
                            <div style={detailStyle}>{specs}</div>
                        </div>
                    </div>
                </div>
                <div style={footerStyle}>
                    <div className="grayButton" style={btnStyle} onClick={this.handleDetailBackButton}>Back</div>
                    <div className="grayButton addToProofStyle" style={btnStyle} onClick={this.handleDetailAddButton}>add to proof</div>
                </div>
            </div>
        )
    }

    getFullSizeProductPopup = () => {
        if(!this.state.selectedSwatch)
            return;

        if(!this.state.zoomProduct)
            return;

        let product: Tgcc.Product = this.state.zoomProduct;

        let fullSizeStyle: CSSProperties = {
            position: 'relative',
            background: 'white',
            border: Tgcc.Styles.singleBorder,
            boxShadow: Tgcc.Styles.boxShadow,
            padding: '20px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-around',
            alignContent: 'center',
            alignSelf: 'center',
            width: '800px',
            height: '1000px',
            maxWidth: '90%',
            maxHeight: '75%',
            '@media (max-width:768px) and (max-height:1024px)': {
                margin:'30px auto'
            },
            '@media (max-width:375px)': {
                maxWidth:'80%',
                maxHeight:'70%'
            }

        };

        let imgStyle: CSSProperties = {
            position: 'relative',
            maxWidth: '80%',
            maxHeight: '75%',
            width: 'auto',
            height: 'auto',
            alignSelf: 'center',
            cursor: 'zoom-out',
        };

    
        let footerStyle: CSSProperties ={
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            width: '100%'
        }
        let addStyle: CSSProperties = {
            backgroundColor: Tgcc.Styles.buttonBackground,
            border: '1px solid none',
            fontSize: '14px',
            lineHeight: '30px',
            fontFamily: 'CenturyGothic',
            textTransform: 'uppercase',
            width: '200px',
            cursor: 'pointer',
            display: 'flex',
            alignSelf: 'center',
            justifyContent: 'center'
        };
        let arrowStyle: CSSProperties = {
            cursor: 'pointer',
            fontSize: '70px',
            height: '40px',
            lineHeight: '30px',
            color: 'darkgray',
            display: 'flex',
            alignSelf: 'center'
        }

        return ( 
            <ScreenDoor>
                <div style={fullSizeStyle}>
                    <CloseX closeAction={this.hideFullSizeProduct} />
                    <img style={imgStyle} src={product.image} onClick={this.hideFullSizeProduct}/>
                    <div style={footerStyle}>
                        <div style={arrowStyle} onClick={this.setPreviousSwatch}>&lsaquo;</div>
                        <div className="hoverBorder" style={addStyle} onClick={this.handleDetailAddButton}>add to proof</div>
                        <div style={arrowStyle} onClick={this.setNextSwatch}>&rsaquo;</div>
                    </div>  
                </div>
            </ScreenDoor>
        )
    }

    setPreviousSwatch = (evt: React.MouseEvent<HTMLDivElement>) => {
        evt.stopPropagation();
        var curIndex = this.state.selectedSwatch.displayIndex - 1;
        curIndex = curIndex < 0 ? this.state.StyleSet.length - 1 : curIndex;
        var prev = this.state.StyleSet[curIndex];
        this.setState({selectedSwatch: prev, zoomProduct: prev});
    }

    setNextSwatch = (evt: React.MouseEvent<HTMLDivElement>) => {
        evt.stopPropagation();
        var curIndex = this.state.selectedSwatch.displayIndex + 1;
        curIndex = curIndex >= this.state.StyleSet.length ? 0 : curIndex;
        var next = this.state.StyleSet[curIndex];
        this.setState({selectedSwatch: next, zoomProduct: next});
    }

    handleDetailBackButton = () => {
        this.setState( { product: null});
    }

    handleDetailAddButton = (evt: React.MouseEvent<HTMLDivElement>) => {
        evt.stopPropagation();
        this.props.dispatch( { type: Tgcc.StateAction.UpdateProofProduct, payload: this.state.selectedSwatch});
    }

    handleSwatchClick = (swatchProduct : Tgcc.Product) => {
        this.setState({selectedSwatch: swatchProduct});
    }

    handleTextSearch = (evt: React.KeyboardEvent<HTMLInputElement>) => {
        if(evt.keyCode == 13){ // return keyCode
            this.filterProductsBySearch(evt.currentTarget.value);
        }

        var style = evt.currentTarget.attributes['style'];
        if(style && style.value){
            if(evt.currentTarget.value)
                evt.currentTarget.attributes['style'].value = style.value.replace('letter-spacing: 6px','letter-spacing: 1px');
            else
                evt.currentTarget.attributes['style'].value = style.value.replace('letter-spacing: 1px','letter-spacing: 6px');
        }
    }

    handleTextSearchBlur = (evt: React.FocusEvent<HTMLInputElement>) => {
        var srch = evt.currentTarget as HTMLInputElement;
        var srchComp = !srch.value ? null : srch.value; // make sure "" is set to null
        if(this.state.filter != srchComp){
            this.filterProductsBySearch(srch.value);
        }
    }

    filterProductsBySearch(filter: string){
        filter = filter && filter.length ? filter : null;
        this.setState({filter: filter, Products: null});

        // 0 == ALL Categories
        var catId = 0;
        if(this.state.category)
            catId = this.state.category.id;
        TgccRequest.getProductsByCategoryBrandFiltered(null, catId, this.state.brand, filter, (products : Tgcc.Product[]) => this.productsLoaded(products));
    }

    closeSelector = () => {
        this.handleBackToProof();
    }
    onSubmit(e){
        console.log('submitting...');
        e.preventDefault();
    }
    mobileCheck() {
        var isMobile = {
            Android: function() {
                return navigator.userAgent.match(/Android/i);
            },
            BlackBerry: function() {
                return navigator.userAgent.match(/BlackBerry/i);
            },
            iOS: function() {
                return navigator.userAgent.match(/iPhone|iPad/i);
            },
            Opera: function() {
                return navigator.userAgent.match(/Opera Mini|Opera Mobi/i);
            },
            Windows: function() {
                return navigator.userAgent.match(/IEMobile/i);
            },
            any: function() {
                return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
            }
        };
        if (isMobile.any()){
            return (
                <form style={searchFormStyle} onSubmit={this.onSubmit}>
                    <input type="text" style={searchStyle} className="searchStyle" placeholder="Search" onBlur={this.handleTextSearchBlur} onKeyUp={this.handleTextSearch}/>
                    <input style={searchBtn} type="submit" value=""/>
                </form>
            )
        }
        return <input type="text" style={searchStyle} placeholder="Search Products" onBlur={this.handleTextSearchBlur} onKeyUp={this.handleTextSearch}/>
    }

    render() {
        var productCategories = this.state.ProductCategories ? this.getProductCategories() : <Tgcc.LoadingElement />;
        var searchBlock = this.mobileCheck();
        return (
            <ScreenDoor>
            <div key="3" className="selectorStyle" style={selectorStyle}>
                <div key="4" style={categoryContainerStyle}>
                        <CloseX closeAction={this.closeSelector} />
                    {searchBlock}
                    <BulletLine text="or" fontSize="12px" bulletSize="3px"/>
                    <div style={smHeadStyle}>choose a feature below</div>
                    <div style={categoryListStyle}>
                        {productCategories}
                    </div>
                </div>
                <div style={catalogStyle}>
                    {this.getProductBrands()}
                    {this.getProductItems()}
                </div>
                {this.getProductDetail()}
                {this.getFullSizeProductPopup()}
                {this.getBackButton()}
            </div>
            </ScreenDoor>
        )
    }
}

var productSelector = Radium(_ProductSelector);
const mapStateToProps = (state : Tgcc.GlobalState, ownState: any) => {
    return {
        proof: state.ActiveProof,
        searchFilter: state.FilterProductsBySearch
    }
};

export var ProductSelector = connect(mapStateToProps)(productSelector);